<template>
  <div class="ProjectUserListItem">
    <div>
      <div class="list-header" :style="index === selectedIndex && isEditOccupation ? 'height: auto;' : ''">
        <div style="display: flex; justify-content: space-between; width: 100%; align-items: center">
          <fieldsContainer v-if="index === selectedIndex && isEditOccupation" style="width: 100%">
            <inputContainer class="full" style="display: flex">
              <multiselect
                class="boon-multiselect NewOccupation"
                :custom-label="(o) => getNewOccupations(o)"
                :disabled="!hasSimplePermissions('saveProjectProperties')"
                :multiple="false"
                :options="newOccupationList"
                :placeholder="$t('Choose or enter responsibility')"
                @input="selectedOccupation($event)"
                :value="selectedNewOccupation"
                label="occupation"
              >
                <div slot="noResult">
                  {{ $t('No match found') }}
                </div>
              </multiselect>
              <button class="material-button-effect" @click="updateOccupation()">Spara</button>
              <button v-if="userItem.occupation" class="material-button-effect" @click="cancelEdit()">Tillbaka</button>
            </inputContainer>
          </fieldsContainer>
          <div class="title" v-if="index !== selectedIndex" @click="showEditing">
            {{ $t(userItem.occupation) }}
          </div>
          <div class="title" v-if="index === selectedIndex && !isEditOccupation">
            {{ $t(userItem.occupation) }}
            <!-- <input v-if="isEditOccupation" class="new-add" type="text" @input="changeOccupation($event)" :value="userItem.occupation"/> -->
          </div>
          <div v-if="index === selectedIndex && !isEditOccupation" class="action">
            <!-- :style="isEditOccupation ? 'display: block;' : '' " -->
            <button @click="editOccupation"><b-icon icon="pencil-fill" /></button>
            <button @click="deleteOccupation"><b-icon icon="trash-fill" /></button>
          </div>
          <div v-if="index !== selectedIndex" class="action">
            <button @click="addNewRow"><b-icon icon="plus" scale="2" /></button>
            <button v-if="!userItem.occupation" @click="deleteOccupation"><b-icon icon="trash-fill" /></button>
          </div>
        </div>
      </div>

      <fieldsContainer>
        <inputContainer>
          <div class="multiselect-placeholder" v-if="!editing && index !== selectedIndex" @click="showEditing">
            {{ companyAndPersonName(userItem.personId) }}
          </div>
          <multiselect
            v-else
            class="boon-multiselect"
            :custom-label="(p) => companyAndPersonName(p._id)"
            :disabled="isEditOccupation || !hasSimplePermissions('saveProjectProperties')"
            :multiple="false"
            :options="groupedPersons()"
            :placeholder="$t('Choose Company And Person')"
            :value="selectedUser"
            @input="updateUserProperty('companyId', $event ? $event : '')"
            group-label="companyName"
            group-values="persons"
            track-by="_id"
            ref="multiselect"
          >
            <div slot="noResult">
              {{ $t('No matching person found') }}
            </div>
          </multiselect>
        </inputContainer>
      </fieldsContainer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import fieldsContainer from '@/components/form/fieldsContainer';
import inputContainer from '@/components/form/inputContainer';
import BLabelled from '@/components/toolbar/BLabelled';
import Multiselect from 'vue-multiselect';

export default {
  name: 'ProjectUserListItem',
  data() {
    return {
      selectedNewOccupation: null,
      editing: false,
    };
  },
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
    userItem: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    selectedIndex: {
      type: Number,
      default: -1,
    },
    newOccupationList: {
      type: Array,
      default: () => [],
    },
    isEditOccupation: {
      type: Boolean,
    },
  },
  methods: {
    ...mapActions(['saveProjectProperties']),
    /**
     * update company and person
     * @param property, value
     */
    updateUserProperty: function (property, newValue) {
      // this.$emit('update', {userItem: this.userItem, property, newValue});
      let companyId = newValue.companyId;
      let companyProperty = 'companyId';

      let personId = newValue._id;
      let personProperty = 'personId';
      this.$emit('update', { userItem: this.userItem, property: companyProperty, newValue: companyId });
      setTimeout(() => {
        this.$emit('update', { userItem: this.userItem, property: personProperty, newValue: personId });
      }, 500);

      this.editing = false;
      // this.$emit('update', {userItem: this.userItem, personProperty, personId});
    },

    /**
     * occupation edit event pass parent
     */
    editOccupation: function () {
      this.$emit('editOccupation');
    },
    /**
     * add new occupation event pass parent
     */
    addNewRow: function () {
      // this.selectedIndex = this.index;
      // this.isEditOccupation = true;
      // console.log(this.index, this.isEditOccupation);
      this.$emit('addNew', { selectedIndex: this.index + 1 });
    },
    /**
     * new occupation selected event pass parent
     * @param occupation
     */
    selectedOccupation: function (event) {
      this.selectedNewOccupation = event;
      // console.log(JSON.stringify(this.selectedNewOccupation));
    },
    updateOccupation: function () {
      // console.log(JSON.stringify(this.selectedNewOccupation));
      this.$emit('updateOccupation', {
        selectedIndex: this.index,
        occupation: this.selectedNewOccupation.occupation,
      });
    },
    /**
     * new occupation delete event pass parent
     * @param occupation
     */
    deleteOccupation: function () {
      this.$emit('deleteOccupation', { selectedIndex: this.index });
    },
    showEditing: function () {
      this.editing = true;

      setTimeout(() => {
        this.$refs.multiselect.$el.focus();
      });
    },
    getNewOccupations: function (item) {
      /* let list = this.newOccupationList.map(item => {
        item.occupation = this.$t(item.occupation);
        return item;
      }); */
      // return item.occupation;
      // console.log(this.$t(item.occupation), item.occupation);
      return this.$t(item.occupation);
    },
    cancelEdit: function () {
      this.$emit('editOccupation');
    },
  },
  computed: {
    ...mapGetters([
      'getCompany',
      'getPerson',
      'hasSimplePermissions',
      'companies',
      'companiesByOccupation',
      'groupedPersons',
      'companyAndPersonName',
    ]),
    roleCompanies() {
      return [
        {
          group: this.$t(this.userItem.occupation),
          /** @todo Why we have to filter by translated value? */
          companies: this.companiesByOccupation({ occupation: this.$t(this.userItem.occupation) }),
        },
        {
          group: this.$t('All'),
          companies: this.companies,
        },
      ];
    },
    selectedUser: function () {
      if (!this.userItem.personId && !this.userItem.companyId) {
        return {};
      }
      // console.log(this.userItem.personId, JSON.stringify(this.getPerson(this.userItem.personId)));
      let person = this.getPerson(this.userItem.personId);
      if (person.companyId === this.userItem.companyId) {
        return person;
      } else {
        return '';
      }
    },
    selectedCompany: function () {
      if (!this.userItem.companyId) {
        return {};
      }
      // console.log(this.userItem.companyId, JSON.stringify(this.getCompany(this.userItem.companyId)));
      // this.getCompany(this.userItem.companyId);
      // this.getPerson(this.userItem.personId);
      return this.getCompany(this.userItem.companyId);
    },
  },
  components: {
    BLabelled,
    fieldsContainer,
    inputContainer,
    Multiselect,
  },
  mounted: async function () {
    // console.log(JSON.stringify(this.newOccupationList));
    // console.log(JSON.stringify(this.groupedPersons()));
  },
  watch: {
    $route: async function (to, from) {},
  },
};
</script>
<style>
.multiselect-placeholder {
  /* margin-top: 6px; */
  color: white;
  font-family: 'DIN Alternate Bold';
  font-size: 26px;
  background: #242f39;
  border: 1px solid #bbb6bb55 !important;
  border-radius: 5px;
  min-height: 44px;
  line-height: 44px;
  padding-left: 5px;
}
.ProjectUserListItem {
  font-size: 12px !important;
  color: #fff;
  padding-left: 13px;
}
.ProjectUserListItem .list-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 20px;
  padding-top: 20px;
  line-height: 20px;
}
.ProjectUserListItem .inputContainer {
  margin: 7px 0px;
  width: calc(100% - 15px) !important;
}
.ProjectUserListItem .fieldsContainer {
  flex-direction: column;
}
.ProjectUserListItem:hover .action {
  display: block;
}
.ProjectUserListItem .action {
  margin-right: 20px;
  display: none;
}
.ProjectUserListItem .title {
  height: 20px;
  font-family: 'DIN-Light';
  font-size: 14px;
}
.ProjectUserListItem .action img {
  height: 15px;
  width: 15px;
  margin-left: 5px;
  cursor: pointer;
}
.ProjectUserListItem .material-button-effect {
  border: 2px solid #bbb6bb55 !important;
  padding: 5px;
  border-radius: 5px;
  font-size: 18px;
  height: 44px;
  min-width: 70px;
  margin-left: 15px;
  position: relative;
}
/* Overlay */
.ProjectUserListItem .material-button-effect::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(var(--pure-material-onprimary-rgb, 255, 255, 255));
  opacity: 0;
  transition: opacity 0.2s;
}

/* Ripple */
.ProjectUserListItem .material-button-effect::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  padding: 50%;
  width: 32px; /* Safari */
  height: 32px; /* Safari */
  background-color: rgb(var(--pure-material-onprimary-rgb, 255, 255, 255));
  opacity: 0;
  transform: translate(-50%, -50%) scale(1);
  transition: opacity 1s, transform 0.5s;
}

/* Hover, Focus */
.ProjectUserListItem .material-button-effect:hover,
.ProjectUserListItem .material-button-effect:focus {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.ProjectUserListItem .material-button-effect:hover::before {
  opacity: 0.08;
}

.ProjectUserListItem .material-button-effect:focus::before {
  opacity: 0.24;
}

.ProjectUserListItem .material-button-effect:hover:focus::before {
  opacity: 0.3;
}
/* Active */
/* .material-button-effect:active {
      box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  } */

.ProjectUserListItem .material-button-effect:active::after {
  opacity: 0.32;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0s;
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectUserListItem.vue